type statuValue = string;
type statusCode = null | undefined | string | number;
type RecommendationType = 'MENTOR' | 'COMMUNITY_SESSION';

export interface IStatus {
  value: statuValue;
  code: statusCode;
}

export interface IError {
  message: string;
  status: string;
  code?: number;
  __type?: string;
}

export interface IImage {
  large: string;
  small: string;
}

export interface IProfileGridItemProps {
  title: string;
  labelValues: any;
  classes: any;
  children?: any;
  infoText?: string;
  actionHandler?: any;
}
export enum ProfileActionType {
  REQUEST_CREDIT = 'REQUEST_CREDIT',
}

export interface IInputFieldProps {
  value: any;
  label: string;
  checked?: boolean;
  actionLabel?: string;
  actionHandler?: any;
  actionToggle?: string;
  onToggle?: (checked: boolean) => void;
  className?: string;
  hasDivider?: boolean;
}

export interface IUnsubscribeProps {
  onUnsubscribe?: any;
  subscriptionEndDate?: string;
  subscriptionStatus: string;
}

export enum EventType {
  ONE_ON_ONE = 'ONE_ON_ONE',
  WORKSHOP = 'WORKSHOP',
  WEBINAR = 'WEBINAR',
  EXERCISE = 'EXERCISE',
  EXCHANGE_GROUP = 'EXCHANGE_GROUP',
  MEDITATION = 'MEDITATION',
}

export enum languageType {
  ENGLISH = 'en',
  GERMAN = 'de',
}

export interface ISubscription {
  id: string;
  active: boolean;
  companyId: string;
  createdAt: string;
  creditAmount: number;
  end: string;
  start: string;
  updatedAt: string;
  type: SubscriptionType;
}

export type SubscriptionType = 'CREDITS' | 'UNLIMITED';

export enum AssessmentType {
  DIGITAL_TWIN = 'DIGITAL_TWIN',
  PRODUCT = 'PRODUCT',
}
export enum AssessmentStatus {
  COMPLETED = 'COMPLETED',
  SKIPPED = 'SKIPPED',
}

export enum GenderType {
  FEMALE = 'FEMALE',
  MALE = 'MALE',
  UNKNOWN = 'UNKNOWN',
}
export interface IAssessment {
  id: string;
  createdAt: string;
  updatedAt: string;
  userId: string;
  type: AssessmentType;
  outcome: AssessmentStatus;
  submittedAt: string;
}
export interface ILastAssessment {
  DIGITAL_TWIN: IAssessment;
  PRODUCT_RECOMMENDATION: IAssessment;
}

export interface IUser {
  id: string;
  name: string;
  createdAt: string;
  email: string;
  firstName: string;
  lastName: string;
  companyId: string;
  dataConsent: boolean;
  marketingConsent: boolean;
  creditBalance: number;
  subscription: ISubscription;
  lastAssessment: ILastAssessment;
  marketingReminderDismissed: boolean;
  locale: string;
  recommendationsConsent: boolean;
}
export interface IBooking {
  bookingId: string;
  offeringId: string;
  cancelUrl: string;
  endsAt: string;
  index: number;
  joinUrl: string;
  mentor: {
    name: string;
    profileImage: string;
  };
  name: string;
  startsAt: string;
  type: EventType;
  duration?: number | string;
}
export interface ISession {
  id: string;
  createdAt: string;
  updatedAt: string;
  name: string;
  index: number;
  offeringId: string;
  startsAt: string;
  endsAt: string;
  mentorId: string;
}

export interface IMentor {
  id: string;
  createdAt: string;
  updatedAt: string;
  name: string;
  email: string;
  profileImage: string;
  details: IMentorDetails;
  languages?: Array<string>;
  focusTopics?: Array<string>;
  isRecommended?: boolean;
}

export interface IMentors {
  mentors: Array<IMentorDetails>;
}
export interface IMentorDetails {
  active: boolean;
  email: string;
  name: string;
  gender: GenderType;
  profileImage: string;
  videoUrl?: string;
  bookingUrl: string;
  education: string;
  description: string;
  languages?: Array<string>;
  focusTopics?: Array<string>;
  work?: Array<IMentorContent>;
  approach: string;
  educationBackground?: Array<IMentorContent>;
}
export interface IMentorContent {
  title: string;
  subtitle: string;
}
export interface IBookingEvent {
  id: string;
  name: string;
  type: EventType;
  description: string;
  maxParticipants: number;
  numberOfBookings: number;
  price: number;
  duration: string;
  bookingUrl: string;
  startDate: string;
  sessions: ISession[];
  language: string;
  topic: string;
  topics: string[];
  mentor?: IMentor;
  isRecommended?: boolean;
}
export interface IMeditation {
  description: string;
  language: string;
  name: string;
  url: string;
  topic: string;
}
export interface IExercise {
  audio: string;
  description: string;
  language: string;
  name: string;
  pdf: string;
  audiotopic: string;
}

export interface Recommendations {
  id: string;
  type: RecommendationType;
  recommendations: Array<IMentor | IBookingEvent>;
  allRecommendations: {
    COMMUNITY_SESSION: Array<IBookingEvent>;
    MENTOR: Array<IMentor>;
  };
  createdAt: string;
}

export interface IRecommendedMentors {
  createdAt: string;
  id: string;
  recommendations: Array<IMentor>;
}

export interface Topic {
  createdAt: string;
  deleted: boolean;
  id: number;
  key: string;
}

export enum cognitoErrorType {
  USER_NOT_FOUND_EXCEPTION = 'UserNotFoundException',
  NOT_AUTHORIZED_EXCEPTION = 'NotAuthorizedException',
  USER_NOT_CONFIRMED_EXCEPTION = 'UserNotConfirmedException',
  USERNAME_EXISTS_EXCEPTION = 'UsernameExistsException',
  USER_LAMBDA_VALIDATION_EXCEPTION = 'UserLambdaValidationException',
  EXPIRED_CODE_EXCEPTION = 'ExpiredCodeException',
  LIMIT_EXCEED_EXCEPTION = 'LimitExceededException',
}

export type Features = Record<string, boolean>;
